import React from "react";
import IntlMessages from "util/IntlMessages";
import { isWebview } from "../../util/generalFunction";
import { Link, withRouter } from "react-router-dom";

class SuperAdminMobileScreen extends React.Component {
  componentDidMount() {
    // isWebview() ? null : this.props.history.push('/') ;
  }
  render() {
    return (
      <div className="app-wrapper page-error-container animated slideInUpTiny animation-duration-3">
        <div className="page-error-content">
          <div className="error-code mb-4 animated zoomInDown">
            <img src="assets/images/error.png" />
          </div>
          <h2 className="text-center fw-regular title bounceIn animation-delay-10 animated">
            Sorry, you cannot use the super admin area in the mobile app. Please use the Vibo Vibo website instead.
          </h2>
          {/* <form className="mb-4" role="search">
            <div className="search-bar flipInX animation-delay-16 animated">
              <div className="form-group">
                <input
                  type="search"
                  className="form-control form-control-lg border-0"
                  placeholder="Search..."
                />
                <button className="search-icon">
                  <i className="zmdi zmdi-search zmdi-hc-lg" />
                </button>
              </div>
            </div>
          </form> */}
          <p className="text-center zoomIn animation-delay-20 animated">
            Here is link to log in using your browser : <button onClick={() => window.postMessage(JSON.stringify({
              external_url_open: "https://www.vibovibo.com"
            }))} target="_blank">vibovibo.com</button>
          </p>
        </div>
      </div>
    );

  }
}

export default withRouter(SuperAdminMobileScreen);



// WEBPACK FOOTER //
// ./components/SuperAdminMobileScreen/index.js